module.exports = __webpack_public_path__ + "f5ae46b2496c702f855840a853f4441d.pdf";